/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { useState, useContext } from "react";
import {
  UmbracoContext,
  UmbracoStep,
  UmbracoChildren,
} from "../../../components/Umbraco/UmbracoContext";
import { NumericFormat } from 'react-number-format';
import QuestionFooter from "./QuestionFooter";
import utils from "../../../utils";
import { LabelTitle, LabelError, RowCenter, Slide,Line } from 'meitav-uikit';

const { UmbracoUtills } = utils;
import { Parser as HtmlToReactParser } from 'html-to-react';
const htmlToReactParser = new HtmlToReactParser();

export default function Question2(props) {

  const { stepActive, anserOld, resourceIcon, setNextDisabled } = props;

  const htmlToReactParser = new HtmlToReactParser();

  const resource = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Question2"
  );
  const scores = UmbracoChildren(
    useContext(UmbracoContext).resource,
    "Question2"
  );
  const Validations = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Validations"
  );
  const [age, setAge] = useState(0);
  const [ageError, setAgeError] = useState(false);
  const [firstLoad, setFirstLoad] = useState("");


  const changeAge = (age) => {
    setAge(age);
    let score = 0;
    scores.map((singleElemJson) => {
      const { value } = singleElemJson[1];
      if (
        value.split("-").length == 2 &&
        age <= value.split("-")[1] &&
        age >= value.split("-")[0]
      )
        score = singleElemJson[2].value;
    });
    setNextDisabled(false);
    props.changeAnswerFunc(stepActive, age, score);

  };
  const changeSlider = (event) => {
    changeAge(event);

    setAgeError(false);
  };
  if (firstLoad != stepActive) {
    setAge(anserOld);
    setFirstLoad(stepActive);
    if (anserOld) {
      changeAge(anserOld);
      setNextDisabled(false);

     // props.changeAnswerFunc(stepActive, Number(anserOld));
    }
  }
  const onChange = (event) => {
    const action_name2 = `${event} גיל בשנים`;
    window.dataLayer.push({
      event: "PM - private details",
      eventInfo: {
        action_screen: window.location.pathname,
        user_age: `${event}`,
        process_level: "פרטים אישיים",
        action_name: action_name2,
      },
    });
  };
  const handleBlur = (event) => {
    onChange(event.target.value);
    setAgeError(false);
    if (event.target.value) {
      if (event.target.value < 18 || event.target.value > 120) {
        setAgeError(true);
           props.changeAnswerFunc(stepActive, event.target.value);

        setAge(event.target.value );
      } else changeAge(event.target.value);
    }

  };

  return (
    <>
      <LabelTitle type="title">{htmlToReactParser.parse(UmbracoUtills.getValueByKey(resource, "title"))}   </LabelTitle>
      <RowCenter>   
     
        <NumericFormat
          id="Question2"
          className="inputNumber "
          value={age}

          fixedDecimalScale
          decimalScale={0}
          pattern="[0-9]*"
          onBlur={handleBlur}
          aria-describedby="ageError"
          aria-required="true"
        />

        {ageError ? (
          <Line>
          <LabelError >
            {UmbracoUtills.getValueByKey(Validations, "ageError")}
          </LabelError></Line>
        ) : null}

      </RowCenter>
      <Slide
        value={age}
        minValue={18}
        step={1}
        maxValue={120}
        onChange={changeSlider}
        onBlur={() => onChange(age)}
      />
      <QuestionFooter
        icon={UmbracoUtills.getValueByKey(resourceIcon, "icon")}
        iconUp={UmbracoUtills.getValueByKey(resourceIcon, "iconUp")}
        iconDown={UmbracoUtills.getValueByKey(resourceIcon, "iconDown")}
        whyImportant={UmbracoUtills.getValueByKey(resource, "whyImportant")}
        tooltip={UmbracoUtills.getValueByKey(resource, "tooltip")}
        text={UmbracoUtills.getValueByKey(resource, "text")}
      />
    </>
  );
}
